import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export function getCsrfToken() {
  const match = document.cookie.match(/XSRF-TOKEN=([^;]+)/);
  return match ? decodeURIComponent(match[1]) : null;
}

const urls = {
// BASE_URL: "http://localhost:8081",
     BASE_URL: "https://products.zedock.com/api-gateway",

  CDN_URL: "https://cdn.zedock.com/",
  // CDN_URL: "https://cdn.zedock.com/",


};

export default urls;
